import React, { useState } from "react";
import {
    Grid,
    Typography,
    ListItem,
} from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { makeStyles } from "@material-ui/core/styles";
import { Draggable } from 'react-beautiful-dnd';
import FabButton from "@icarius-common/fabButton";
import DataItem from "./detail/dataItem";

const useStyles = makeStyles({
    noPadding: {
        padding: '0px'
    }
});

const StepContainer = ({ title, children }) => {
    return (
        <Grid container item xs={12} justify="center" style={{ marginTop: 20 }}>
            <Grid container item sm={12} md={10}>
                <Typography className="whiteText" style={{ fontSize: 20, width: '100%', padding: '0px 10px' }}>
                    {title}
                </Typography>
                <Grid container item alignItems="center" justify="space-between" xs={12} style={{ paddingTop: 10 }}>
                    {children}
                </Grid>
            </Grid>
        </Grid>
    )
}

const Details = (props) => {
    const {
        detailList,
        activityList,
        materialsList,
        setFormValue,
        actionTypeList,
        momentList,
    } = props;

    const [createIsOpen, setCreateIsOpen] = useState(false);
    const classes = useStyles();

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onDragEnd = ({ destination, source }) => {
        if (!destination) return; // dropped outside the list
        const newItems = reorder(detailList, source.index, destination.index);
        setFormValue(newItems.map((item, index) => ({ ...item, number: index + 1 })), "details");
    };

    return (
        <StepContainer title={getLocalizedString("onboardingStepsForProfile")}>
            <Grid container item xs={12}>
                <div style={{ width: "100%" }}>
                    <FabButton title={getLocalizedString("newStep")} onClick={() => setCreateIsOpen(true)} />
                    {
                        createIsOpen &&
                        <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                            <DataItem
                                data={null}
                                detailList={detailList}
                                activityList={activityList}
                                materialsList={materialsList}
                                actionTypeList={actionTypeList}
                                momentList={momentList}
                                setFormValue={setFormValue}
                                closeNew={() => setCreateIsOpen(false)}
                            />
                        </Grid>
                    }
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable-list">
                            {
                                provided => (
                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                        {
                                            detailList.map((item, index) => (
                                                <Grid container item xs={12} key={index.toString()}>
                                                    <Draggable draggableId={index.toString()} index={index}>
                                                        {
                                                            (provided) => (
                                                                <ListItem
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className={classes.noPadding}
                                                                >
                                                                    <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                                                                        <DataItem
                                                                            data={item}
                                                                            detailList={detailList}
                                                                            activityList={activityList}
                                                                            materialsList={materialsList}
                                                                            actionTypeList={actionTypeList}
                                                                            momentList={momentList}
                                                                            setFormValue={setFormValue}
                                                                        />
                                                                    </Grid>
                                                                </ListItem>
                                                            )
                                                        }
                                                    </Draggable>
                                                </Grid>
                                            ))
                                        }
                                        {provided.placeholder}
                                    </div>
                                )
                            }
                        </Droppable>
                    </DragDropContext>
                </div>
            </Grid>
        </StepContainer>
    )
}


export default Details;
